module.exports = __webpack_public_path__ + "static/media/service2.0224d29f.png";